import { render } from "./PdfDoc.vue?vue&type=template&id=74205503&scoped=true"
import script from "./PdfDoc.vue?vue&type=script&lang=js"
export * from "./PdfDoc.vue?vue&type=script&lang=js"

import "./PdfDoc.vue?vue&type=style&index=0&id=74205503&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74205503"]])

export default __exports__